<template>
	<div class="safety-permit-maintenance">
		<div class="safety-permit-container">
			<!-- <div class="safety-permit-title">
				<h3>人员信息配置</h3>
			</div> -->

			<div class="safety-permit-content">
				<!-- 左侧人员类型导航 -->
				<div class="personnel-type-nav">
					<div
						v-for="(item, index) in personnelTypes"
						:key="index"
						class="personnel-type-item"
						:class="{ active: activeTypeIndex === index }"
						@click="handleChangeType(index)"
					>
						{{ item.name }}
					</div>
				</div>

				<!-- 右侧内容区域 -->
				<div class="personnel-content">
					<!-- 根据选中的类型显示对应的内容 -->
					<div v-for="(item, index) in personnelTypes" v-show="activeTypeIndex === index" :key="index" class="personnel-section">
						<div class="section-header">
							<h4>{{ item.name }}</h4>
							<div v-if="isSetting && item.type !== 'specialWorkers'">
								<el-button type="warning" @click="handleOpenManuallyAdd(item.type)">
									手动添加人员
								</el-button>
								<el-button type="primary" @click="handleAddPersonnel(item.type)">
									添加人员
								</el-button>
							</div>
							<div v-if="isSetting && item.type === 'specialWorkers'" class="button-input-container">
								<el-button type="warning" @click="handleOpenManuallyAdd(item.type)">
									手动添加人员
								</el-button>
								<el-button v-if="!searchInputVisible" type="primary" @click="showSearchInput">添加人员</el-button>
								<div v-if="searchInputVisible" class="search-input-group">
									<el-input v-model="searchSfzh" placeholder="请输入身份证号点击添加" clearable></el-input>
									<el-button :loading="addLoading" type="primary" @click="addPersonBySfzh">添加</el-button>
									<el-button @click="hideSearchInput">关闭</el-button>
								</div>
							</div>
						</div>

						<!-- 搜索 -->
						<div class="search-container">
							<div class="search-form">
								<div class="form-item">
									<span class="label">姓名：</span>
									<el-input v-model="queryParams.name" placeholder="请输入姓名" clearable></el-input>
								</div>
								<div class="form-item">
									<span class="label">身份证号：</span>
									<el-input v-model="queryParams.sfzh" placeholder="请输入身份证号" clearable></el-input>
								</div>
								<div class="form-buttons">
									<el-button type="primary" @click="handleSearch(item.type, item.typeCode)">查询</el-button>
									<el-button @click="handleResetSearch(item.type, item.typeCode)">重置</el-button>
								</div>
							</div>
						</div>

						<!-- 数据表格 -->
						<data-table
							:table-data="personnelData[item.type] || []"
							:column="personnelColumns"
							:loading="loadingStatus[item.type]"
							:page-options="pageOptions[item.type]"
							:border="true"
							:selection="false"
							:index="true"
							@page-change="pager => handlePageChange(pager, item.type, item.typeCode)"
						>
							<!-- 操作列 -->
							<template slot="slot_action" slot-scope="{ scope }">
								<el-button v-if="isSetting" type="text" @click="handleDelete(scope.row, item.type, item.typeCode)">
									删除
								</el-button>
							</template>
						</data-table>
					</div>
				</div>
			</div>

			<!-- 未绑定企业遮罩层 -->
			<nonbind-enterprise v-if="!isHasCompany"></nonbind-enterprise>
			<!-- 未开通会员提示 -->
			<nonbind-vip v-else-if="isNormalVip"></nonbind-vip>
		</div>

		<!-- 人员库 -->
		<jr-dialog :visible.sync="staffLibraryVisible" title="人员库" width="70%" top="100px" :append-to-body="true">
			<template v-if="staffLibraryVisible" slot="content">
				<staff-library ref="staffLibrary" :is-setting="true" :rylx="activeTypeCode"></staff-library>
			</template>
			<template slot="footer">
				<el-button @click="handleCloseStaff">取 消</el-button>
				<el-button type="primary" :loading="saveStaffLoading" @click="handleSaveStaffInfo">确 定</el-button>
			</template>
		</jr-dialog>

		<!-- 安许-手动添加人员 -->
		<jr-dialog :visible.sync="manuallyAddVisible" title="手动添加人员" width="1400px" top="100px" :append-to-body="true">
			<template v-if="manuallyAddVisible" slot="content">
				<manually-add ref="manuallyAdd" :rylx="activeTypeCode"></manually-add>
			</template>
			<template slot="footer">
				<el-button @click="handleCloseManuallyAdd">取 消</el-button>
				<el-button type="primary" :loading="manuallyAddLoading" @click="handleSubmitManuallyAdd">确 定</el-button>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import DataTable from '@/components/JrTable/DataTable'
	import NonbindVip from '@/components/NonBind/nonbindVip'
	import NonbindEnterprise from '@/components/NonBind/nonbindEnterprise'
	import StaffLibrary from '../components/staffLibrary.vue'
	import ManuallyAdd from '../components/manuallyAdd.vue'
	import { mapGetters } from 'vuex'
	import { isIdCard } from '@/utils/validate'
	import {
		saveAnxyMaterialRecord,
		queryAnxyMaterialRecord,
		queryStaffTzryList,
		removeAnxyMaterialRecord
	} from '@/api/certTreasure/materialRecord'

	// 建筑施工企业安全生产许可证-资质材料维护
	export default {
		name: 'SafetyPermitMaintenance',
		components: {
			JrDialog,
			DataTable,
			NonbindVip,
			NonbindEnterprise,
			StaffLibrary,
			ManuallyAdd
		},
		props: {
			// 是否开启配置
			isSetting: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				// 诊断记录id
				diagnosisRecordId: '',
				// 人员类型列表
				personnelTypes: [
					// { name: '主要负责人（企业经理）', type: 'manager' },
					// { name: '企业分管安全副经理', type: 'safetyManager' },
					{ name: '企业持证A证人员', type: 'certificateA', typeCode: '9' },
					{ name: '项目负责人', type: 'projectManager', typeCode: '7' },
					// { name: '安全生产管理机构负责人', type: 'safetyOrgManager' },
					{ name: '安全生产管理机构人员', type: 'safetyOrgStaff', typeCode: '5' },
					{ name: '施工现场专职安全生产管理人员', type: 'siteManager', typeCode: '6' },
					{ name: '特种作业人员', type: 'specialWorkers', typeCode: '8' }
				],
				// 人员配置搜索
				queryParams: {
					name: '',
					sfzh: ''
				},
				// 当前选中的人员类型索引
				activeTypeIndex: 0,
				// 当前人员类型编码
				activeTypeCode: '',
				// 表格加载状态（每种类型单独控制）
				loadingStatus: {
					certificateA: false,
					projectManager: false,
					safetyOrgStaff: false,
					siteManager: false,
					specialWorkers: false
				},
				// 分页配置（每种类型单独控制）
				pageOptions: {
					certificateA: { page: 1, limit: 10, total: 0 },
					projectManager: { page: 1, limit: 10, total: 0 },
					safetyOrgStaff: { page: 1, limit: 10, total: 0 },
					siteManager: { page: 1, limit: 10, total: 0 },
					specialWorkers: { page: 1, limit: 10, total: 0 }
				},
				// 各类型人员数据
				personnelData: {
					// 企业持证A证人员
					certificateA: [],
					// 项目负责人
					projectManager: [],
					// 安全生产管理机构人员
					safetyOrgStaff: [],
					// 施工现场专职安全生产管理人员
					siteManager: [],
					// 特种作业人员
					specialWorkers: []
				},
				// 人员库弹窗
				staffLibraryVisible: false,
				// 人员库人员选择保存loading
				saveStaffLoading: false,
				// 搜索输入框是否可见
				searchInputVisible: false,
				// 搜索的身份证号
				searchSfzh: '',
				// 人员搜索添加loading
				addLoading: false,

				// 手动添加人员弹窗
				manuallyAddVisible: false,
				// 手动添加人员弹窗loading
				manuallyAddLoading: false
			}
		},
		computed: {
			...mapGetters(['isHasCompany', 'vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			// 动态生成表格列配置
			personnelColumns() {
				// 基础列配置
				const columns = [
					{ prop: 'name', label: '姓名', minWidth: '100' },
					{ prop: 'certificateName', label: '证书类型', minWidth: '140' },
					{ prop: 'sfzh', label: '身份证号', minWidth: '180' },
					{ prop: 'zsbh', label: '证书编号', minWidth: '120' },
					{ prop: 'yxqjssj', label: '证书有效期', minWidth: '120' },
					{ prop: 'fzdw', label: '发证单位', minWidth: '150' }
				]

				// 如果当前不是特种作业人员类型，则添加等级列
				const currentType = this.personnelTypes[this.activeTypeIndex]?.type
				if (currentType !== 'specialWorkers') {
					// 在证书编号后添加等级列
					columns.splice(4, 0, { prop: 'certificateGrade', label: '等级', minWidth: '80' })
				}

				// 如果是设置模式，添加操作列
				if (this.isSetting) {
					columns.push({ slot: 'slot_action', label: '操作', minWidth: '80', fixed: 'right' })
				}

				return columns
			}
		},
		watch: {},
		created() {},
		mounted() {
			// 获取诊断记录对应的记录id
			this.diagnosisRecordId = this.$route.query && this.$route.query.recordId
			this.activeTypeCode = this.personnelTypes[this.activeTypeIndex].typeCode
			// 已绑定企业，并且成为了vip或者svip
			if (this.isHasCompany && (this.isVip || this.isSVip)) {
				this.fetchAllPersonnelData()
			}
		},
		methods: {
			// 切换人员类型
			handleChangeType(index) {
				this.activeTypeIndex = index
				const activeTypeCode = this.personnelTypes[index].typeCode
				const activeType = this.personnelTypes[index].type
				this.activeTypeCode = activeTypeCode

				// 切换时，重置一下每项搜索条件
				this.queryParams = {
					name: '',
					sfzh: ''
				}

				this.fetchPersonnelData(activeType, activeTypeCode)
			},

			// 查询所有类型的人员数据
			fetchAllPersonnelData() {
				this.personnelTypes.forEach(item => {
					this.fetchPersonnelData(item.type, item.typeCode)
				})
			},

			// 获取指定类型的人员数据
			fetchPersonnelData(type, rylx) {
				this.loadingStatus[type] = true

				const params = {
					page: this.pageOptions[type].page,
					size: this.pageOptions[type].limit,
					rylx: rylx,
					...this.queryParams,
					diagnosisRecordId: this.diagnosisRecordId ? this.diagnosisRecordId : '001'
				}

				queryAnxyMaterialRecord(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.personnelData[type] = data.records
							this.pageOptions[type].total = data.total
						} else {
							this.personnelData[type] = []
							this.pageOptions[type].total = 0
						}
						this.loadingStatus[type] = false
					})
					.catch(error => {
						this.personnelData[type] = []
						this.pageOptions[type].total = 0
						this.loadingStatus[type] = false
					})
			},

			// 分页变化
			handlePageChange(pager, type, rylx) {
				this.pageOptions[type].page = pager.page
				this.pageOptions[type].limit = pager.limit
				this.fetchPersonnelData(type, rylx)
			},

			// 搜索
			handleSearch(type, rylx) {
				this.pageOptions[type].page = 1
				this.pageOptions[type].limit = 10
				this.fetchPersonnelData(type, rylx)
			},

			// 重置搜索
			handleResetSearch(type, rylx) {
				this.queryParams = {
					name: '',
					sfzh: ''
				}
				this.fetchPersonnelData(type, rylx)
			},

			// 打开企业人员库选择人员
			handleAddPersonnel(type) {
				if (type === 'specialWorkers') {
					return
				}
				this.staffLibraryVisible = true
			},

			// 显示搜索输入框
			showSearchInput() {
				this.searchInputVisible = true
			},

			// 隐藏搜索输入框
			hideSearchInput() {
				this.searchInputVisible = false
				this.searchSfzh = ''
			},

			// 根据身份证号添加人员
			async addPersonBySfzh() {
				if (!this.searchSfzh) {
					this.$modal.msgWarning('请输入身份证号')
					return
				}

				if (!isIdCard(this.searchSfzh)) {
					this.$modal.msgWarning('请输入正确格式的身份证号')
					return
				}

				try {
					// 显示加载状态
					this.addLoading = true
					const responsePerson = await queryStaffTzryList({ idCard: this.searchSfzh, certificateType: '9' })

					if (!responsePerson.data.records || !responsePerson.data.records.length) {
						this.$modal.msgWarning('未查询到人员信息')
						return
					}

					const person = responsePerson.data.records[0]
					// 插入人员时，指定插入类型
					person.rylx = this.activeTypeCode
					person.personId = person.id
					// 把原表的主键id置为空
					person.id = ''

					// 保存人员信息
					await saveAnxyMaterialRecord({ dataJson: [person] })

					// 操作成功
					this.$modal.msgSuccess('保存成功')
					this.hideSearchInput()
					this.fetchAllPersonnelData()
				} catch (error) {
					// 错误处理
					console.error('添加人员失败:', error)
				} finally {
					// 无论成功与否，都关闭
					this.addLoading = false
				}
			},

			// 保存安许资质材料人员维护信息
			handleSaveStaffInfo() {
				console.log('staffIdArray:', this.$refs.staffLibrary.staffIdArray)
				const selectPersons = this.$refs.staffLibrary.staffIdArray
				if (selectPersons.length === 0) {
					this.$modal.msgWarning('请选择人员')
					return
				}

				const data = {
					dataJson: null
				}

				// 插入人员时，指定插入类型
				data.dataJson = selectPersons.map(item => ({
					...item,
					personId: item.id,
					// 把原表的主键id置为空
					id: '',
					rylx: this.activeTypeCode
				}))

				this.saveStaffLoading = true
				saveAnxyMaterialRecord(data)
					.then(response => {
						this.$modal.msgSuccess('保存成功')
						this.saveStaffLoading = false
						this.staffLibraryVisible = false
						this.fetchAllPersonnelData()
					})
					.catch(error => {
						this.saveStaffLoading = false
					})
			},

			// 关闭材料维护
			handleCloseStaff() {
				this.staffLibraryVisible = false
			},

			/**
			 * 删除已维护的人员
			 * @param {*} row 行数局
			 * @param {*} type 数据类型
			 * @param {*} rylx 人员类型
			 */
			handleDelete(row, type, rylx) {
				console.log('row:', row)
				console.log('type:', type)

				const data = {
					id: row.id
				}

				this.$modal
					.confirm('请确认是否删除该人员信息？')
					.then(() => {
						return removeAnxyMaterialRecord(data)
					})
					.then(() => {
						this.$modal.msgSuccess('操作成功')
						this.fetchPersonnelData(type, rylx)
					})
					.catch(() => {})
			},

			// 手动添加人员弹窗关闭
			handleCloseManuallyAdd() {
				this.manuallyAddVisible = false
			},

			// 手动添加人员弹窗打开
			handleOpenManuallyAdd() {
				this.manuallyAddVisible = true
			},

			// 手动添加人员弹窗提交
			async handleSubmitManuallyAdd() {
				this.$refs.manuallyAdd
					.handleSaveManualAdd()
					.then(async response => {
						const data = {
							dataJson: [
								{
									...response,
									rylx: this.activeTypeCode
								}
							]
						}

						// 提交表单数据
						try {
							this.manuallyAddLoading = true
							await saveAnxyMaterialRecord(data)
							this.$modal.msgSuccess('保存成功')
							this.manuallyAddLoading = false
							this.handleCloseManuallyAdd()
							this.fetchAllPersonnelData()
						} catch (error) {
							this.manuallyAddLoading = false
						}
					})
					.catch(error => {
						console.error('手动添加人员失败:', error)
					})
			},

			// 诊断材料提交处材料信息保存
			saveMaintenanceInfoPromise() {
				// 安许不需要校验表单是否填写，所以这里直接resolve
				return new Promise((resolve, reject) => {
					resolve()
				})
			},

			// 验证资质诊断材料是否维护
			handleValidMaintenanceInfoIsSetting() {
				// // 定义需要验证的人员类型
				// const requiredTypes = [
				// 	'certificateA', // 企业持证A证人员
				// 	'projectManager', // 项目负责人
				// 	'safetyOrgStaff', // 安全生产管理机构人员
				// 	'siteManager', // 施工现场专职安全生产管理人员
				// 	'specialWorkers' // 特种作业人员
				// ]

				// // 遍历需要验证的人员类型，检查是否有数据
				// for (const type of requiredTypes) {
				// 	const personnelList = this.personnelData[type] || []

				// 	// 如果某类人员数据为空，弹出提示并返回false
				// 	if (personnelList.length === 0) {
				// 		// 找出某一项未维护类型
				// 		// const typeName = this.personnelTypes.find(item => item.type === type)?.name || type

				// 		return false
				// 	}
				// }
				// 以上逻辑屏蔽，因安许不需要全部人员都维护就可以进行诊断

				// 所有必填人员类型都已维护
				return true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.safety-permit-maintenance {
		// padding: 20px;

		.safety-permit-container {
			background-color: #fff;
			border-radius: 4px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
			position: relative;

			.safety-permit-title {
				padding: 15px 20px;
				border-bottom: 1px solid #ebeef5;

				h3 {
					margin: 0;
					font-size: 18px;
					font-weight: 500;
					color: #333;
				}
			}

			.safety-permit-content {
				display: flex;
				min-height: 600px;

				.personnel-type-nav {
					width: 240px;
					border-right: 1px solid #ebeef5;

					.personnel-type-item {
						padding: 15px 20px;
						cursor: pointer;
						transition: all 0.3s;
						border-bottom: 1px solid #ebeef5;
						color: #606266;

						&:hover {
							background-color: #f5f7fa;
						}

						&.active {
							color: #236fca;
							background-color: #ecf5ff;
							border-left: 4px solid #236fca;
						}
					}
				}

				.personnel-content {
					flex: 1;
					padding: 20px;
					overflow-y: auto;

					.personnel-section {
						// margin-bottom: 30px;

						.section-header {
							display: flex;
							justify-content: space-between;
							align-items: center;
							margin-bottom: 15px;
							position: relative;

							h4 {
								margin: 0;
								font-size: 16px;
								font-weight: 500;
								color: #333;
							}

							.button-input-container {
								display: flex;
								align-items: center;
								width: auto;
								overflow: hidden;
								white-space: nowrap;
							}

							.search-input-group {
								display: flex;
								align-items: center;
								animation: slideInRight 0.3s ease forwards;
								background-color: white;
								padding-left: 5px;
								box-sizing: border-box;

								.el-button {
									margin-left: 5px;
								}

								.el-input {
									margin-right: 10px;
									width: 200px;
								}
							}
						}

						.search-container {
							padding: 10px;
							// margin-bottom: 20px;

							.search-form {
								display: flex;
								flex-wrap: wrap;
								gap: 20px;

								.form-item {
									display: flex;
									align-items: center;

									.label {
										white-space: nowrap;
										margin-right: 8px;
										color: #606266;
									}

									.el-input {
										width: 200px;
									}

									.el-select {
										width: 200px;
									}

									.el-date-picker {
										width: 400px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@keyframes slideInLeft {
		from {
			transform: translateX(-100%);
			opacity: 0;
		}
		to {
			transform: translateX(0);
			opacity: 1;
		}
	}

	@keyframes slideInRight {
		from {
			transform: translateX(100%);
			opacity: 0;
		}
		to {
			transform: translateX(0);
			opacity: 1;
		}
	}
</style>
